var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "18px",
    viewBox: "0 0 33 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-1",
    transform: "translate(-22.000000, -136.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2136015,142.043969 L48.0111469,136.917971 C47.7596481,136.669572 47.4183745,136.53 47.0625035,136.53 C46.7066325,136.53 46.3653588,136.669572 46.11386,136.917971 L46.11386,136.917971 C45.5939852,137.433927 45.5939852,138.267216 46.11386,138.783173 L50.8872462,143.492477 L23.5408388,143.492477 C22.800314,143.492477 22.2,144.084731 22.2,144.815315 L22.2,144.815315 C22.2,145.545898 22.800314,146.138153 23.5408388,146.138153 L50.9676965,146.138153 L46.11386,150.920213 C45.8620813,151.168336 45.7206099,151.505028 45.7206099,151.856121 C45.7206099,152.207215 45.8620813,152.543907 46.11386,152.792029 L46.11386,152.792029 C46.3653588,153.040428 46.7066325,153.18 47.0625035,153.18 C47.4183745,153.18 47.7596481,153.040428 48.0111469,152.792029 L53.2136015,147.652803 C54.7821328,146.103402 54.7821328,143.59337 53.2136015,142.043969 Z",
    transform: "translate(38.295000, 144.855000) rotate(-180.000000) translate(-38.295000, -144.855000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.923c5b9b.svg";
export { ForwardRef as ReactComponent };